import styled from 'styled-components';

// Main container with themed surface background
export const OptionsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 0.5rem;
  background: var(--surface-2);
  border: 1px solid var(--border-subtle);
  padding: 1rem;
  border-radius: 12px;
  backdrop-filter: blur(10px);
`;

// Hidden checkbox remains unchanged (functional)
export const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
`;

// Themed checkbox
export const StyledCheckbox = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  background: ${props => props.checked ? 'var(--accent)' : 'var(--input-bg)'};
  border: 1px solid ${props => props.checked ? 'var(--accent)' : 'var(--border-default)'};
  border-radius: 4px;
  margin-right: 8px;
  transition: all 0.2s ease;
  cursor: pointer;
  backdrop-filter: blur(5px);

  &:hover {
    border-color: var(--border-strong);
    background: ${props => props.checked ? 'var(--accent-hover)' : 'var(--input-bg-focus)'};
  }

  ${HiddenCheckbox}:focus + & {
    box-shadow: 0 0 0 2px var(--accent-soft);
    border-color: var(--accent);
  }
`;

// Checkmark icon - adjusted for better visibility
export const Checkmark = styled.svg`
  width: 12px;
  height: 12px;
  fill: none;
  stroke: ${props => props.checked ? 'var(--text-on-accent)' : 'transparent'};
  stroke-width: 2px;
  opacity: ${props => props.checked ? '1' : '0'};
  transition: opacity 0.2s ease;
`;

// Themed label text
export const OptionLabel = styled.span`
  font-size: 0.85rem;
  color: var(--text-secondary);
  cursor: pointer;
  transition: color 0.2s ease;

  &:hover {
    color: var(--text-primary);
  }
`;

// Card image with subtle glow effect
export const CardImage = styled.img`
  width: 20px;
  height: 20px;
  margin-right: 8px;
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid var(--border-subtle);
  filter: drop-shadow(var(--shadow-sm));
`;

// Themed columns
export const LeftColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  width: 50%;
  padding: 1rem;
`;

export const RightColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  width: 50%;
  padding: 1rem;
`;

// Main checkbox container
export const CheckboxContainer = styled.div`
`;

// Themed label
export const Label = styled.label`
  font-weight: 600;
  font-size: 0.9rem;
  color: var(--text-heading);
  display: block;
`;

// Main options container
export const OptionsContainer = styled.div`
  display: flex;
  width: 100%;
`;

// Individual option item
export const OptionItem = styled.div`
  display: flex;
  align-items: center;
  padding: 0.5rem 0.75rem;
  width: 100%;
  border-radius: 6px;
  transition: all 0.2s ease;
  cursor: pointer;

  &:hover {
    background: var(--table-row-hover);
    transform: translateX(2px);
  }

  &:active {
    transform: translateX(1px);
  }
`;

// Row with themed styling
export const Row = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
`;
